export const DOWNLOAD_COUNT_ROLES = ['consumer', 'seller']
export const NO_PAYMENT_ROLES = ['broker', 'seller']
export const AVAILABILITY_TYPE_OCCUPIED = 'occupied'
export const AVAILABILITY_TYPE_UNOCCUPIED = 'unoccupied'
